import ApiService from "@/core/services/api.service";

export default {
  selectAvailable(query = {}) {
    return ApiService.query('contractor/available_orders', query)
  },
  selectActive(query = {}) {
    return ApiService.query('contractor/active_orders', query)
  },
  accept(id, vehicleId) {
    return ApiService.post(`contractor/available_orders/${id}/accept`, { vehicle_id: vehicleId })
  },
  reject(id) {
    return ApiService.post(`contractor/available_orders/${id}/reject`)
  }
}
